import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "w-1/2 prose prose-indigo" }
const _hoisted_3 = { class: "float-left inline text-6xl leading-16 w-16 text-center" }
const _hoisted_4 = { class: "mt-0 min-h-[4rem]" }
const _hoisted_5 = ["src", "alt", "width", "height"]


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideStep',
  props: {
  step: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  img: {
    type: String,
    required: true,
  },
  imgWidth: {
    type: Number,
    required: true,
  },
  imgHeight: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `step${__props.step}`,
    class: "flex flex-col gap-6 bg-white shadow mt-6 p-6 pb-10 rounded sm:flex-row"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.step), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("img", {
      class: "w-full border border-black/10 rounded-md shadow sm:w-1/2 mb-auto",
      src: __props.img,
      alt: __props.title,
      width: __props.imgWidth,
      height: __props.imgHeight
    }, null, 8, _hoisted_5)
  ], 8, _hoisted_1))
}
}

})